export const getArtBoardShapePathEl = (self) => {
  return self._art_board_shape_path_el ?? null;
};
